import { keys, httpStatus } from '../../common/constants'
import { LOGOUT_USER } from '../../store/user/actionTypes'

export function getAccessToken() {
    return localStorage.getItem(keys.JWT_TOKEN)
}

export function saveAuthorizationToken(token) {
    localStorage.setItem(keys.JWT_TOKEN, token);
}

export function removeAuthorizationToken() {
    localStorage.removeItem(keys.JWT_TOKEN)
}

export function getAuthorizationToken() {
    var token = localStorage.getItem(keys.JWT_TOKEN)
    if (!token) token = ''
    const authString = `Bearer ${token}`
    return authString
}

export function isUnauthorizedCall(dispatch, response) {
    if (!response) return false
    else if (response.status == httpStatus.UNAUTHORIZED) {
        dispatch({ type: LOGOUT_USER })
        localStorage.removeItem(keys.JWT_TOKEN)
        return true
    }
    else return false
}



// WEBPACK FOOTER //
// ./src/common/helpers/authorization.js